<template>
  <v-app>
    <div style="margin-top:20px;">
      <v-main>
        <v-container>
          <v-row align-center justify-center>
            <v-col cols="6" align="right">
              <img
                src="@/assets/cronos-white.png"
                style="width:90px; filter:invert()"
              />
            </v-col>
            <v-col cols="6" align="left" align-self="center">
              <h1>Kronos</h1>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-row align="center" justify="center" v-if="!loadingSSO">
            <v-col cols="10" sm="10" md="3">
              <div>
                <v-alert
                  v-model="alert"
                  dismissible
                  type="error"
                  v-t="'messages.error.invalidCredentials'"
                ></v-alert>
                <v-alert
                  v-model="alertSSO"
                  dismissible
                  type="error"
                  v-t="'messages.error.serverSSO'"
                ></v-alert>
              </div>
              <v-form id="formLogin" @submit.prevent="submit" ref="form">
                <v-text-field
                  v-model="username"
                  prepend-icon="mdi-account"
                  name="login"
                  :label="$t('login.labels.username')"
                  :rules="LoginRules"
                  required
                  type="text"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  prepend-icon="mdi-lock"
                  name="password"
                  :rules="PasswordRules"
                  required
                  :label="$t('login.labels.password')"
                  id="password"
                  type="password"
                ></v-text-field>
                <v-btn
                  class="my-5"
                  block
                  type="submit"
                  v-t="'login.labels.login'"
                ></v-btn>
              </v-form>
              <v-divider></v-divider>
              <v-btn
                v-if="false"
                block
                @click="connectBySSO"
                color="blue-grey"
                class="my-5 white--text"
              >
                <v-icon left dark>mdi-account-key</v-icon>
                {{ $t("login.labels.loginCentralized") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import {AUTH_REQUEST, AUTH_REQUEST_SSO} from "app/store/types";
import {mapActions} from "vuex";
import {EventBus} from "@/tools/event-bus";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      alert: false,
      alertSSO: false,
      valid: false,
      loadingSSO: false,
      LoginRules: [v => !!v || "Identifiant absent"],
      PasswordRules: [v => !!v || "Mot de passe absent"],
      ssoUrl: process.env.VUE_APP_SSO_URL
    };
  },
  mounted() {
    let code = this.$route.query.code;
    if (code) {
      this.loadingSSO = true;
      this.getToken(code);
    } else {
      EventBus.$emit("stop-loading");
    }
  },
  methods: {
    ...mapActions([AUTH_REQUEST, AUTH_REQUEST_SSO]),
    getToken: async function (code) {
      try {
        await this[AUTH_REQUEST_SSO]({code});
      } catch (error) {
        this.alertSSO = true;
      }
      EventBus.$emit("stop-loading");
      await this.$router.push("/");
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.login();
      }
    },
    connectBySSO() {
      EventBus.$emit("start-loading");
      const data = {
        response_type: "code",
        scope: "openid profile email",
        state: "leha",
        client_id: "kronos",
        redirect_uri: window.location.href
      };
      const searchParams = new URLSearchParams(data);

      window.location = `${
        this.ssoUrl
      }/cas/oidc/authorize?${searchParams.toString()}`;
    },
    login: async function () {
      EventBus.$emit("start-loading");
      const {username, password} = this;
      try {
        await this[AUTH_REQUEST]({username, password});
      } catch (error) {
        this.alert = true;
      }
      EventBus.$emit("stop-loading");
      await this.$router.push("/");
    }
  }
};
</script>

<style scoped>
h1 {
  color: #000000;
  font-size: 34px;
  font-weight: 300;
}
</style>
